module.exports = __webpack_public_path__ + "static/Structured list-7eb80a2acd82a967808ee93a4b7031b9.svg";